import React, { ReactElement } from 'react'
import { Route, Switch, Redirect, useLocation } from 'react-router-dom'
import Page from '../../hoc/Page'
import CardTabs from '../../components/page/CardTabs'
import CardTab from '../../components/page/CardTab'
import { RoutePath } from '../../types/Routes'
import { useOrganisation } from '../../context/OrganisationProvider'
import ManageCategories from './ManageCategories'
import Card, { CardSize } from '../../components/page/Card'
import { capitalize } from '../../helpers/DataTransformer'
import { itemWord } from '../../helpers/FormatHelper'
import ManagePromotions from './ManagePromotions'
import OrganisationRoute from '../../components/routing/OrganisationRoute'
import PromotionSettings from './promotion/PromotionSettings'
import ManageGiftItems from './ManageGiftItems'

// This page is a container for other pages. We are doing it this way so that the breadcrumbs and
// active link in the menu work as expected.

// By doing it this way, when you change to either tab, you remain on the same "manage" page.

export default function Manage(): ReactElement {
  const { organisation } = useOrganisation()
  const location = useLocation()

  // This sets the default page
  if (location.pathname === RoutePath.Manage) {
    return <Redirect to={RoutePath.ItemGrid} />
  }

  const itemWording = `${capitalize(itemWord(organisation))}`

  return (
    <Page>
      <Card cardSize={CardSize.Big}>
        <CardTabs>
          <CardTab title={`${itemWording}s`} to={RoutePath.ItemGrid} />
          <CardTab title={`${itemWording} table`} to={RoutePath.ItemTable} />
          {organisation?.categoriesEnabled ? (
            <CardTab title="Categories" to={RoutePath.ManageCategories} />
          ) : null}
          {organisation?.hasPromotions ? (
            <CardTab title="Promotions" to={RoutePath.ManagePromotions} />
          ) : null}
        </CardTabs>
        <Switch>
          <Route
            exact={true}
            path={RoutePath.ItemGrid}
            render={(): ReactElement => <ManageGiftItems type="grid" />}
          />
          <Route
            exact={true}
            path={RoutePath.ItemTable}
            render={(): ReactElement => <ManageGiftItems type="table" />}
          />
          <OrganisationRoute
            exact={true}
            path={RoutePath.ManageCategories}
            component={ManageCategories}
            requiredVar="categoriesEnabled"
          />
          <OrganisationRoute
            exact={true}
            path={RoutePath.ManagePromotions}
            component={ManagePromotions}
            requiredVar="hasPromotions"
          />
        </Switch>
      </Card>
      <OrganisationRoute
        exact={true}
        path={RoutePath.ManagePromotions}
        component={PromotionSettings}
        requiredVar="hasPromotions"
      />
    </Page>
  )
}
